import React, { useEffect, useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'

import { getSolarStorageGroup, getSolarPlant } from 'api/pgads.js'
import R from 'ramda'

import {
  deleteSolarStorageInverterGroupFormation,
  getSolarStorageInverterGroupFormationByPlantandStorage,
  updateSolarStorageInverterGroupFormation,
} from '../solarapi'

import CommonScreen from 'admin/component/CommonScreen'
import { modifiedDateCol, modifierCol } from 'core/HeaderColTypeProps'
import { Label } from 'core/screen-util'
import { Button, Input, Select, message } from 'antd'
import { getApiTargetInfo } from 'core'
import { connect } from 'react-redux'
import { toSelectionColProps } from '@integec/grid-tools'

const SolarInvrterFormation = ({ apiTargetInfo }) => {
  const [insertEvent, setInsertEvent] = useState(false)
  const [plantMap, setPlantMap] = useState({})
  const [subGroupMap, setSubGroupMap] = useState({})

  useEffect(
    _ => {
      getSolarPlant(apiTargetInfo).fork(
        _ => _,
        data => {
          const pm = R.reduce(
            (a, b) => ({ ...a, ...b }),
            {},
            data.map(d => ({ [d.plantId]: d.plantName }))
          )
          setPlantMap(pm)
        }
      )

      getSolarStorageGroup(apiTargetInfo).fork(
        _ => _,
        data => {
          const pm = R.reduce(
            (a, b) => ({ ...a, ...b }),
            {},
            data.map(d => ({
              [d.plantId + '-' + d.storageGroupId]: d.storageGroupName,
            }))
          )

          setSubGroupMap(pm)
        }
      )
    },
    [apiTargetInfo]
  )

  const handleAdd = (data, insertData, hide, onAdd) => _ => {
    if (
      data?.find(
        d =>
          d.plantId === insertData.plantId &&
          d.inverterId === insertData.inverterId
      )
    ) {
      message.error('Plant and inverter pair must be unique.')
    } else {
      onAdd(hide)
    }
  }

  const insertComp = ({
    data,
    insertData = {},
    setInsertData,
    onAdd,
    onCancel,
  }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '80px 250px 150px 250px 80px 250px 80px 250px',
          gap: 10,
          width: 1000,
        }}
      >
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>Plant :</Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        {/* <Input
          value={insertData.plantId}
          onChange={e =>
            setInsertData({
              ...insertData,
              plantId: e.target.value,
            })
          }
        /> */}
        <Select
          id="plant"
          showSearch
          style={{ width: '100%' }}
          value={insertData.plantId}
          onChange={val => setInsertData({ ...insertData, plantId: val })}
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {R.compose(
            R.sortBy(R.prop('value')),

            R.map(([k, v]) => ({ id: k, value: v })),
            R.toPairs
          )(plantMap).map(k => (
            <Select.Option value={k.id} key={k.id}>
              {/* {`${k}-${keymap[k]}`} */}
              {`${k.value}`}
            </Select.Option>
          ))}
        </Select>
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Storage Group Id :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Select
          showSearch
          id="subgroup"
          data-cy="select"
          style={{ width: '100%' }}
          value={insertData.inverterGroupIdMain}
          onChange={val =>
            setInsertData({
              ...insertData,
              inverterGroupIdMain: val,
              storageGroupId: val.substr(val.indexOf('-') + 1),
            })
          }
          filterOption={(input, option) =>
            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >=
            0
          }
        >
          {R.compose(
            R.sortBy(R.prop('value')),
            R.filter(
              d => d.id.substr(0, d.id.indexOf('-')) === insertData.plantId
            ),
            R.map(([k, v]) => ({ id: k, value: v })),
            R.toPairs
          )(subGroupMap).map(k => (
            <Select.Option value={k.id} key={k.id} data-cy="select">
              {/* {`${k}-${keymap[k]}`} */}
              {`${k.value}`}
            </Select.Option>
          ))}
        </Select>
        {/* <Input
          value={insertData.inverterGroupId}
          onChange={e =>
            setInsertData({
              ...insertData,
              inverterGroupId: e.target.value,
            })
          }
        /> */}
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>
            Inverter Id :
          </Label>
          <span style={{ color: 'red', marginRight: '2px', float: 'right' }}>
            *
          </span>
        </div>
        <Input
          value={insertData.inverterId}
          placeholder="Inverter"
          onChange={e =>
            setInsertData({
              ...insertData,
              inverterId: e.target.value,
            })
          }
        />
        <div>
          <Label style={{ display: 'inline', float: 'right' }}>Block :</Label>
        </div>
        <Input
          value={insertData.inverterBlock}
          placeholder="Block"
          onChange={e =>
            setInsertData({
              ...insertData,
              inverterBlock: e.target.value,
            })
          }
        />
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1fr 1fr 1fr',
            gap: 10,
            gridColumnStart: '5',
            gridColumnEnd: 'span 2',
          }}
        >
          <Button
            type="primary"
            onClick={handleAdd(data, insertData, true, onAdd)}
          >
            Add
          </Button>
          <Button
            type="primary"
            onClick={handleAdd(data, insertData, false, onAdd)}
          >
            Add & Hide
          </Button>
          <Button type="danger" onClick={onCancel}>
            Cancel
          </Button>
        </div>
      </div>
    )
  }

  const SolarSubgroupFormationHeaders = [
    strCol({
      ident: 'plantId',
      display: 'Plant',
      isKey: true,
      width: 250,
      sortOrder: 'asc',
      ...toSelectionColProps(plantMap),
      dataFormatter: ({ value }) =>
        plantMap[value] ? value + '-' + plantMap[value] : value,
      sortIndexGetter: ({ rowData }) =>
        plantMap[rowData.plantId] || rowData.plantId,
    }),
    strCol({
      ident: 'storageGroupId',
      display: 'Storage Group Id',
      isKey: true,
      width: 250,
      sortOrder: 'asc',
      dataFormatter: ({ value, rowData }) =>
        subGroupMap[rowData.plantId + '-' + value]
          ? value + '-' + subGroupMap[rowData.plantId + '-' + value]
          : value,
      sortIndexGetter: ({ rowData }) =>
        subGroupMap[rowData.inverterGroupId] || rowData.inverterGroupId,
      // ...toSelectionColProps(subGroupMap),
    }),
    strCol({
      ident: 'inverterId',
      display: 'Inverter Id',
      isKey: true,
      width: 250,
      sortOrder: 'asc',
    }),
    strCol({
      ident: 'inverterBlock',
      display: 'Block',
      width: 250,
      sortOrder: 'asc',
      ellipsis: true,
    }),
    modifierCol,
    modifiedDateCol,
  ]
  return (
    <CommonScreen
      title="Solar Storage Group Formation"
      header={SolarSubgroupFormationHeaders}
      sortOptions={SolarSubgroupFormationHeaders}
      saveTask={updateSolarStorageInverterGroupFormation}
      retrieveTask={getSolarStorageInverterGroupFormationByPlantandStorage}
      deleteTask={deleteSolarStorageInverterGroupFormation}
      autoRetrieve
      insertComp={insertEvent && insertComp}
      insertCompHeight={90}
      onInsertEvent={b => setInsertEvent(b)}
      headerRowHeight={30}
      // heightOffset={100}
      withImport
      importUrl="screen-csv-import-file"
      importData={{ importType: 'SOLAR_STORAGE_INVERTER_GROUP_FORMATION' }}
    />
  )
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

export default connect(mapStateToProps)(SolarInvrterFormation)
